import React, { FC } from 'react';
import styled from 'styled-components';
import arrowRightIcon from '../../../icons/ic_arrow_right.svg';
import { Link } from 'components/Common';
import Icon from 'components/v2/Icon';
import Typography from '../Typography';

const ActionContainer = styled.div<any>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  text-decoration: none;
`;

interface LinkActionProps {
  id: string;
  onClick?: (event: any) => void;
  text?: string;
  to?: string;
  pagedirection?: string;
  arrow: boolean;
  last?: boolean;
}

export const LinkAction: FC<LinkActionProps> = ({
  id,
  text,
  arrow,
  onClick,
  to,
  pagedirection,
}) => {
  const content = (
    <>
      <Typography variant="titleMedium" color="var(--sys-color--on-surface-variant)">
        {text}
      </Typography>
      {arrow && <Icon url={arrowRightIcon} width={20} height={20} />}
    </>
  );

  const commonProps = {
    onClick,
    id,
    'aria-label': id,
  };

  if (to) {
    return (
      <ActionContainer
        as={Link}
        to={to}
        pageDirection={pagedirection || 'FORWARD'}
        {...commonProps}
      >
        {content}
      </ActionContainer>
    );
  }

  return <ActionContainer {...commonProps}>{content}</ActionContainer>;
};

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
